import { Card, Text } from "@clipboard-health/ui-components";
import { Box, CircularProgress, Stack } from "@mui/material";

import { type ScoreLedgerEntry } from "../../api/useShiftScoreLedger";
import { EmptyStateText } from "../../components/EmptyStateText";
import { ScoreLedgerItem } from "./ScoreLedgerItem";

interface ClipboardScoreCardProps {
  readonly scoreLedger: ScoreLedgerEntry[];
  readonly totalScoreChange: number;
  readonly isLoading: boolean;
}

export function ClipboardScoreCard(props: ClipboardScoreCardProps) {
  const { scoreLedger, totalScoreChange, isLoading } = props;

  return (
    <Card variant="tertiary" sx={(theme) => ({ padding: theme.spacing(5) })}>
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Text semibold variant="body1">
            Clipboard Score
          </Text>
          {scoreLedger.length > 0 && (
            <Text
              semibold
              variant="body2"
              sx={(theme) => ({
                color:
                  totalScoreChange >= 0 ? theme.palette.success.main : theme.palette.error.main,
              })}
            >
              {totalScoreChange >= 0 ? "+" : ""}
              {totalScoreChange} pts
            </Text>
          )}
        </Stack>
        <ScoreLedgerList isLoading={isLoading} scoreLedger={scoreLedger} />
      </Stack>
    </Card>
  );
}

interface ScoreLedgerListProps {
  readonly scoreLedger: ScoreLedgerEntry[];
  readonly isLoading: boolean;
}

function ScoreLedgerList({ scoreLedger, isLoading }: ScoreLedgerListProps) {
  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", padding: 4 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (scoreLedger.length === 0) {
    return <EmptyStateText>Your score wasn&apos;t affected by this shift</EmptyStateText>;
  }

  return (
    <Stack spacing={2}>
      {scoreLedger.map((entry) => (
        <ScoreLedgerItem key={entry.id} entry={entry} />
      ))}
    </Stack>
  );
}
